import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserContext } from '../contexts/UserContext';
import logger from '../utils/logger';
import '../styles/Login.css';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login, isAuthenticated } = useAuth();
    const { setUserContext } = React.useContext(UserContext);

    // Reindirizza alla dashboard se l'utente è già autenticato
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, navigate]);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Importa apiFetch per gestire in modo centralizzato la base URL
            const { apiFetch } = await import('../api/client');
            const response = await apiFetch('/api/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            if (!response.ok) {
                throw new Error('Login fallito: credenziali non valide');
            }

            const data = await response.json();

            // Usa la funzione login del contesto di autenticazione
            login(
                data.token,
                (data.tenantId !== null && data.tenantId !== undefined) ? String(data.tenantId) : undefined,
                data.username,
                data.fullName || ''
            );

            // Sincronizza anche il vecchio UserContext usato da Header/ProtectedRoute
            setUserContext({
                id: data.id,
                username: data.username,
                email: data.email,
                fullName: data.fullName,
                tenantId: data.tenantId,
                tenantName: data.tenantName
            }, data.token);
            if (data.tenantId != null) localStorage.setItem('tenantId', String(data.tenantId));

            logger.debug('Login successful');

            // Se il backend richiede cambio password, salva un flag e poi vai in dashboard
            if (data.mustChangePassword === true) {
                localStorage.setItem('mustChangePassword', '1');
            } else {
                localStorage.removeItem('mustChangePassword');
            }

            // Reindirizza alla dashboard
            navigate('/dashboard');
        } catch (error) {
            console.error('Errore durante il login:', error);
            setError('Login fallito. Verifica username e password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <h1>Tenant Portal</h1>
                <h2>Accedi</h2>
                {error && <div className="error-message">{error}</div>}
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label htmlFor="username">Email o Username</label>
                        <input
                            type="text"
                            id="username"
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Caricamento...' : 'Accedi'}
                    </button>
                </form>
            </div>
        </div>
    );
}
